export const orderStatus = {
  '-1': {
    name: '已取消',
    icon: 'status-close'
  },
  '1': {
    name: '预约中',
    icon: 'status-ongoing'
  },
  '3': {
    name: '服务中',
    icon: 'status-done'
  },
  '5': {
    name: '待支付',
    icon: 'status-warning'
  },
  '7': {
    name: '已完成',
    icon: 'status-done'
  }
}

export const evaluate = {
  '1': {
    name: '强烈推荐'
  },
  '2': {
    name: '满意'
  },
  '3': {
    name: '还可以'
  },
  '4': {
    name: '一般'
  },
  '5': {
    name: '不满意'
  }
}

export const today = {
  text: '今天',
  onClick (picker) {
    picker.$emit('pick', new Date())
  }
}

export const yesterday = {
  text: '昨天',
  onClick (picker) {
    const date = new Date()
    date.setTime(date.getTime() - 3600 * 1000 * 24)
    picker.$emit('pick', date)
  }
}

export const shortcutLastWeek = {
  text: '最近一周',
  onClick (picker) {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    picker.$emit('pick', [start, end])
  }
}

export const shortcutLastMonth = {
  text: '最近一个月',
  onClick (picker) {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    picker.$emit('pick', [start, end])
  }
}

export const shortcutLastThreeMonth = {
  text: '最近三个月',
  onClick (picker) {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
    picker.$emit('pick', [start, end])
  }
}

export const dateRangeShortcut = [
  shortcutLastWeek,
  shortcutLastMonth,
  shortcutLastThreeMonth
]
